import styled from 'styled-components';
import { brand, darkgrey, white } from 'styles/Colors';
import { HotkeyBadgeWrapper } from 'pages/Tagging/components/HotkeyBadge/HotkeyBadgeStyles';
import { DisplayName } from '../../../Option/OptionStyles';

export const FieldingSequencePlayerWrapper = styled.div`
  width: 46px;
  height: 52px;
  background: ${white};
  box-shadow: 0px 2px 15px 0 rgba(0, 0, 0, 0.16);
  border-radius: 5px;
  line-height: 22px;
  position: relative;

  &.selected {
    ${HotkeyBadgeWrapper},
    ${DisplayName} {
      color: ${brand};
    }
  }

  ${DisplayName} {
    font-family: Oswald;
    font-weight: 500;
    font-size: 36px;
    color: ${darkgrey};
  }

  ${HotkeyBadgeWrapper} {
    float: none;
    margin: 0;
    position: absolute;
    bottom: -11px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }

  svg {
    display: none;
  }
`;
